import {MolecularGraph} from "../../graph/MolecularGraph"
import {Features} from "../../feature";
import {rxhExtractor} from "./rxhExtractor";

export const alcoholExtractor = {
    extract: (graph: MolecularGraph) => rxhExtractor.extract("O", Features.alcohol, graph)
}
